import {
  getBlosumScore,
  getEveScores,
  getEveScoreVersion,
  getMitImpactData,
  getMitotipData,
  getMaxentscanData,
  getAlphaMissenseData,
} from "../../../../../../state/selectors/general.selectors";
import {
  getCadd,
  getDann,
  getDbnsfp,
  getDbnsfpDbscsnv,
  getDbnsfpPremium,
} from "../../../../../../state/selectors/InSilicoPredictions.selector";

export const getAllInsilcoData = (state) => {
  const dbnsfpDbscsnvData = getDbnsfpDbscsnv(state)?.[0] || [];
  const caddData = getCadd(state)?.[0] || [];
  const dannData = getDann(state)?.[0] || [];
  const dbnsfpData = getDbnsfp(state)?.[0] || [];
  const dbnsfpPremiumData = getDbnsfpPremium(state)?.[0] || [];
  const eveVersion = getEveScoreVersion(state);
  const eveData = getEveScores(state)?.flat();
  const eveScores = eveData?.map((item) => item?.eve_score);
  const evePathogenicities = eveData?.map((item) => item?.class_75);
  const blosum = getBlosumScore(state);
  const mitotipData = getMitotipData(state);
  const mitImpactData = getMitImpactData(state);
  const maxentscanData = getMaxentscanData(state);
  const alphaMissenseData = getAlphaMissenseData(state);
  const { version: maxentscanVersion, maxentscan_score: maxentscanScores } =
    maxentscanData;

  const allData = {
    ...dbnsfpDbscsnvData,
    ...caddData,
    ...dannData,
    ...dbnsfpData,
    ...dbnsfpPremiumData,
    dbnsfpPremiumVersion: dbnsfpPremiumData?.version,
    dbnsfpVersion: dbnsfpData?.version,
    dannVersion: dannData?.version,
    caddVersion: caddData?.version,
    dbnsfpDbscsnvVersion: dbnsfpDbscsnvData?.version,
    eve_version: eveScores?.length > 0 ? eveVersion : undefined,
    eve_score: eveScores?.length > 0 ? eveScores : undefined,
    eve_pathogenicities:
      evePathogenicities?.length > 0 ? evePathogenicities : undefined,
    blosum,
    ...mitImpactData,
    ...mitotipData,
    maxentscanVersion,
    maxentscanScores,
    ...alphaMissenseData,
  };
  return allData;
};
